import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Image1 from "../../../images/slider/slide3.jpg"
import pic3 from "../../../images/slider/pic3.png"

import { withTranslation } from 'react-i18next';



class Slider2 extends Component {
	constructor(props) {
		super(props);
		this.next = this.next.bind(this);
		this.previous = this.previous.bind(this);
	}
	componentDidMount() {


		this.interval = setInterval(() => {
			this.next();
		}, 8000);
	}
	componentWillUnmount() {
		clearInterval(this.interval);
	}
	next() {
		this.slider.slickNext();
	}
	previous() {
		this.slider.slickPrev();
	}
	render() {
		const { t } = this.props;
		const settings = {
			infinite: true,
			speed: 1000,
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: true,
			initialSlide: 0,
		};

		return (
			<>
				<div className='slider-container'>
					<Slider ref={c => (this.slider = c)} {...settings} className="slideshow-container tt-slider slider-two slider-sp0 owl-none">
						<div className="slider-item" key={1}>
							<div className="slider-thumb">
								<img alt="" src={Image1} />
							</div>
							<div className="slider-content">
								<div className="container">
									<div className="row align-items-center">
										<div className="col-lg-8 col-md-12 col-sm-12">
											<div className="content-inner">
												<h2 className="text-primary">{t('Slider2_Prititle2')}</h2>
												{t('Slider2_Description_1')}
												<ul>
													<li><strong>{t('Slider2_Description_Point1_Title')}</strong> {t('Slider2_Description_Point1_Text')}</li>
													<li><strong>{t('Slider2_Description_Point2_Title')}</strong> {t('Slider2_Description_Point2_Text')}</li>
													<li><strong>{t('Slider2_Description_Point3_Title')}</strong> {t('Slider2_Description_Point3_Text')}</li>
													<li><strong>{t('Slider2_Description_Point4_Title')}</strong> {t('Slider2_Description_Point4_Text')}</li>
													<li><strong>{t('Slider2_Description_Point5_Title')}</strong> {t('Slider2_Description_Point5_Text')}</li>
												</ul>
												<Link to="/courses-details"><h2 className="text-important">{t('Slider2_New_Term')}</h2></Link>
												<Link to="/robotics-for-good/2026/introduction" style={{ fontSize: "20px", fontWeight: "700", textDecoration: "none" }}>{t('Slider2_Description_2')}</Link>
											</div>
										</div>
										<div className="col-lg-4 col-md-12 col-sm-12">
											<div className="slider-img" style={{ width: '120%' }}>
												<img alt="" src={pic3} />
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</Slider>
				</div>
			</>
		);
	}
}

export default Slider2 = withTranslation()(Slider2);